import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const Product = () => {
  const [selectedView, setSelectedView] = useState<'front' | 'side' | 'detail'>('front');
  const [showModal, setShowModal] = useState(false);
  const [rotation, setRotation] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientY - rect.top) / rect.height - 0.5;
    const y = (e.clientX - rect.left) / rect.width - 0.5;
    setRotation({ x: x * -20, y: y * 20 });
  };

  const productViews = {
    front: {
      title: '正面视图',
      image: 'https://readdy.ai/api/search-image?query=Professional%203D%20render%20of%20transparent%20clear%20orthodontic%20aligner%20for%20children%20front%20view%2C%20medical%20grade%20polymer%20material%20with%20smooth%20edges%20and%20precise%20cutting%20craftsmanship%2C%20floating%20on%20clean%20white%20background%20with%20soft%20studio%20lighting%2C%20high%20detail%20product%20photography%20showing%20material%20texture%20and%20transparency%2C%20premium%20medical%20device%20visualization&width=800&height=600&seq=product3d&orientation=landscape',
      description: '完美贴合牙齿表面，透明隐形设计'
    },
    side: {
      title: '侧面视图',
      image: 'https://readdy.ai/api/search-image?query=Professional%203D%20render%20of%20transparent%20clear%20orthodontic%20aligner%20for%20children%20side%20view%20angle%2C%20medical%20grade%20polymer%20material%20showing%20thickness%20and%20edge%20detail%2C%20floating%20on%20clean%20white%20background%20with%20soft%20studio%20lighting%2C%20high%20detail%20product%20photography%20with%20material%20texture%20visible%2C%20premium%20medical%20device%20visualization&width=800&height=600&seq=productside&orientation=landscape',
      description: '精准的厚度设计，舒适不刺激'
    },
    detail: {
      title: '细节特写',
      image: 'https://readdy.ai/api/search-image?query=Extreme%20close-up%20macro%20photography%20of%20transparent%20orthodontic%20aligner%20edge%20detail%2C%20showing%20smooth%20polished%20surface%20and%20precise%20cutting%20craftsmanship%2C%20medical%20grade%20polymer%20material%20texture%20visible%2C%20professional%20product%20photography%20with%20soft%20lighting%20highlighting%20material%20quality%20and%20transparency&width=800&height=600&seq=productdetail&orientation=landscape',
      description: '边缘圆滑处理，无毛刺设计'
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left: Text */}
            <div>
              <div className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-bold mb-6">
                专为儿童设计
              </div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Mirókids<br />硅胶矫治器
              </h1>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                采用医疗级高分子材料，结合AI智能排牙技术，为6-12岁儿童提供舒适、安全、高效的正畸解决方案
              </p>
              <div className="flex flex-wrap gap-4">
                <button 
                  onClick={() => setShowModal(true)}
                  className="bg-blue-600 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
                >
                  查看产品详情
                </button>
                <Link 
                  to="/find-doctor"
                  className="bg-white text-blue-600 border-2 border-blue-600 px-8 py-4 rounded-full text-lg font-bold hover:bg-blue-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  寻找医生
                </Link>
              </div>
            </div>

            {/* Right: 3D Product with View Selector */}
            <div>
              <div className="bg-white rounded-3xl shadow-2xl p-8">
                <div 
                  className="relative h-[500px] mb-6 cursor-pointer group"
                  onClick={() => setShowModal(true)}
                >
                  <img
                    src={productViews[selectedView].image}
                    alt={productViews[selectedView].title}
                    className="w-full h-full object-contain drop-shadow-2xl transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-blue-600/0 group-hover:bg-blue-600/5 transition-colors duration-300 rounded-2xl flex items-center justify-center">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/90 px-6 py-3 rounded-full shadow-lg">
                      <span className="text-blue-600 font-bold flex items-center gap-2">
                        <i className="ri-zoom-in-line text-xl"></i>
                        点击查看大图
                      </span>
                    </div>
                  </div>
                </div>

                {/* View Selector */}
                <div className="flex gap-4 justify-center">
                  {(Object.keys(productViews) as Array<keyof typeof productViews>).map((view) => (
                    <button
                      key={view}
                      onClick={() => setSelectedView(view)}
                      className={`flex-1 py-3 px-4 rounded-xl font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                        selectedView === view
                          ? 'bg-blue-600 text-white shadow-lg'
                          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }`}
                    >
                      {productViews[view].title}
                    </button>
                  ))}
                </div>
                <p className="text-center text-gray-600 mt-4">
                  {productViews[selectedView].description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal for enlarged view */}
      {showModal && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-6"
          onClick={() => setShowModal(false)}
        >
          <div 
            className="bg-white rounded-3xl max-w-5xl w-full p-8 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 w-12 h-12 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl text-gray-700"></i>
            </button>
            
            <h2 className="text-3xl font-bold text-gray-900 mb-6">产品细节展示</h2>
            
            <div className="mb-6">
              <img
                src={productViews[selectedView].image}
                alt={productViews[selectedView].title}
                className="w-full h-[600px] object-contain"
              />
            </div>

            <div className="flex gap-4 mb-6">
              {(Object.keys(productViews) as Array<keyof typeof productViews>).map((view) => (
                <button
                  key={view}
                  onClick={() => setSelectedView(view)}
                  className={`flex-1 py-3 px-4 rounded-xl font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                    selectedView === view
                      ? 'bg-blue-600 text-white shadow-lg'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {productViews[view].title}
                </button>
              ))}
            </div>

            <div className="bg-blue-50 rounded-2xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-3">{productViews[selectedView].title}</h3>
              <p className="text-gray-700 text-lg">{productViews[selectedView].description}</p>
              
              <div className="grid grid-cols-3 gap-4 mt-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-1">0.75mm</div>
                  <div className="text-sm text-gray-600">精准厚度</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-1">100%</div>
                  <div className="text-sm text-gray-600">医疗级材料</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600 mb-1">99%</div>
                  <div className="text-sm text-gray-600">透明度</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="pt-20">
        {/* Hero */}
        <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h1 className="text-5xl font-bold mb-6 text-gray-800">Mirókids 硅胶矫治器</h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                采用先进的数字化技术和医用级材料，为6-12岁儿童量身定制的硅胶矫治方案
              </p>
            </div>

            {/* 3D Product Display */}
            <div className="max-w-4xl mx-auto mb-20">
              <div 
                className="relative h-96 perspective-1000 cursor-pointer"
                onMouseMove={handleMouseMove}
                onMouseLeave={() => setRotation({ x: 0, y: 0 })}
              >
                <div 
                  className="absolute inset-0 flex items-center justify-center transition-transform duration-300"
                  style={{
                    transform: `rotateX(${rotation.x}deg) rotateY(${rotation.y}deg)`
                  }}
                >
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%203D%20render%20of%20transparent%20clear%20orthodontic%20aligner%20for%20children%2C%20medical%20grade%20polymer%20material%20with%20smooth%20edges%20and%20precise%20cutting%20craftsmanship%2C%20floating%20on%20clean%20white%20background%20with%20soft%20studio%20lighting%2C%20high%20detail%20product%20photography%20showing%20material%20texture%20and%20transparency%2C%20premium%20medical%20device%20visualization&width=800&height=600&seq=product3d&orientation=landscape"
                    alt="Mirókids矫治器"
                    className="w-full h-full object-contain drop-shadow-2xl"
                  />
                </div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg">
                  <p className="text-sm text-gray-600">移动鼠标查看细节</p>
                </div>
              </div>
            </div>

            {/* Key Features */}
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-eye-off-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">隐形美观</h3>
                <p className="text-gray-600 leading-relaxed">
                  采用高透明度医用材料，佩戴时几乎看不见，让孩子在矫正过程中保持自信笑容，不影响日常社交
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-heart-3-line text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">舒适体验</h3>
                <p className="text-gray-600 leading-relaxed">
                  轻薄设计仅0.75mm厚度，边缘圆滑无刺激，无金属托槽异物感，孩子更容易适应和坚持佩戴
                </p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                  <i className="ri-delete-bin-line text-3xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-800">可摘戴设计</h3>
                <p className="text-gray-600 leading-relaxed">
                  进食和刷牙时可自由摘戴，不影响口腔清洁，降低龋齿风险，让孩子享受美食无负担
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Material Technology */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">材料科技</h2>
            
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <img 
                  src="https://readdy.ai/api/search-image?query=Close-up%20macro%20photography%20of%20medical%20grade%20transparent%20polymer%20material%20showing%20smooth%20surface%20texture%20and%20molecular%20structure%2C%20professional%20laboratory%20lighting%20highlighting%20material%20clarity%20and%20flexibility%2C%20clean%20white%20scientific%20background%2C%20high%20resolution%20material%20science%20visualization%2C%20premium%20quality%20medical%20device%20material&width=800&height=600&seq=material&orientation=landscape"
                  alt="医用级材料"
                  className="rounded-2xl shadow-2xl w-full h-96 object-cover"
                />
              </div>
              
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-gray-800">医用级安全材料</h3>
                    <p className="text-gray-600 leading-relaxed">
                      采用通过FDA和CFDA双重认证的高分子聚合物材料，不含BPA等有害物质，对儿童口腔环境完全安全无刺激
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-leaf-line text-2xl text-orange-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-gray-800">优异的柔韧性</h3>
                    <p className="text-gray-600 leading-relaxed">
                      材料具有出色的弹性记忆功能，能够持续施加温和而稳定的矫治力，确保牙齿移动的精准性和可预测性
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-star-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-gray-800">抗断裂能力强</h3>
                    <p className="text-gray-600 leading-relaxed">
                      经过特殊工艺处理，材料韧性提升40%，即使儿童活动量大也不易破损，大大降低更换频率和治疗成本
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-contrast-drop-line text-2xl text-purple-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-gray-800">抗着色性能</h3>
                    <p className="text-gray-600 leading-relaxed">
                      材料表面经过纳米级抗污处理，有效抵抗食物色素沉积，长期佩戴仍能保持透明清澈的外观
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Digital Technology */}
        <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-center mb-6 text-gray-800">AI数字化技术</h2>
            <p className="text-center text-gray-600 mb-16 max-w-3xl mx-auto text-lg">
              运用人工智能和大数据分析，为每个孩子设计最优矫治方案
            </p>

            <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
              <div className="order-2 md:order-1 space-y-6">
                <div className="bg-white rounded-2xl p-6 shadow-lg">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-xl">1</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2 text-gray-800">3D口腔扫描</h3>
                      <p className="text-gray-600 leading-relaxed">
                        采用iTero口扫仪进行数字化取模，全程无需传统印模材料，3-5分钟即可完成，孩子无不适感
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-xl">2</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2 text-gray-800">AI智能排牙</h3>
                      <p className="text-gray-600 leading-relaxed">
                        基于10万+儿童矫治数据训练的AI系统，自动生成最优移动路径，精确到0.1mm的移动量控制
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <span className="text-white font-bold text-xl">3</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2 text-gray-800">可视化预览</h3>
                      <p className="text-gray-600 leading-relaxed">
                        家长和孩子可通过3D动画提前看到整个矫治过程和最终效果，增强治疗信心和配合度
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="order-1 md:order-2">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20AI%20dental%20treatment%20planning%20system%20interface%20showing%203D%20tooth%20arrangement%20visualization%20on%20computer%20screen%2C%20futuristic%20medical%20technology%20with%20blue%20holographic%20displays%2C%20professional%20dental%20clinic%20environment%2C%20high-tech%20digital%20orthodontic%20software%2C%20clean%20and%20precise%20visualization%2C%20advanced%20medical%20technology%20concept&width=800&height=600&seq=aitech&orientation=landscape"
                  alt="AI排牙系统"
                  className="rounded-2xl shadow-2xl w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Tech Stats */}
            <div className="grid md:grid-cols-4 gap-6">
              <div className="bg-white rounded-xl p-6 text-center shadow-lg">
                <div className="text-4xl font-bold text-blue-600 mb-2">0.1mm</div>
                <div className="text-gray-600">移动精度</div>
              </div>
              <div className="bg-white rounded-xl p-6 text-center shadow-lg">
                <div className="text-4xl font-bold text-blue-600 mb-2">10万+</div>
                <div className="text-gray-600">数据样本</div>
              </div>
              <div className="bg-white rounded-xl p-6 text-center shadow-lg">
                <div className="text-4xl font-bold text-blue-600 mb-2">95%</div>
                <div className="text-gray-600">方案准确率</div>
              </div>
              <div className="bg-white rounded-xl p-6 text-center shadow-lg">
                <div className="text-4xl font-bold text-blue-600 mb-2">3-5分钟</div>
                <div className="text-gray-600">扫描时间</div>
              </div>
            </div>
          </div>
        </section>

        {/* Comparison */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">为什么选择硅胶矫治</h2>
            
            <div className="overflow-x-auto">
              <table className="w-full bg-white rounded-2xl shadow-lg overflow-hidden">
                <thead>
                  <tr className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
                    <th className="py-6 px-6 text-left text-lg font-bold">对比项目</th>
                    <th className="py-6 px-6 text-center text-lg font-bold">Mirókids硅胶矫治</th>
                    <th className="py-6 px-6 text-center text-lg font-bold">传统金属矫治</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { item: '美观度', mirokids: '几乎隐形', traditional: '明显金属托槽' },
                    { item: '舒适度', mirokids: '光滑无异物感', traditional: '有刺痛和磨嘴' },
                    { item: '口腔清洁', mirokids: '可摘戴，易清洁', traditional: '难以清洁，易龋齿' },
                    { item: '饮食限制', mirokids: '无限制', traditional: '不能吃硬物和粘性食物' },
                    { item: '复诊频率', mirokids: '4-6周一次', traditional: '2-4周一次' },
                    { item: '治疗时长', mirokids: '12-18个月', traditional: '18-24个月' },
                    { item: '紧急情况', mirokids: '少见', traditional: '托槽脱落较常见' }
                  ].map((row, index) => (
                    <tr key={index} className={index % 2 === 0 ? 'bg-blue-50/50' : 'bg-white'}>
                      <td className="py-5 px-6 font-semibold text-gray-800">{row.item}</td>
                      <td className="py-5 px-6 text-center">
                        <span className="inline-flex items-center gap-2 text-green-600 font-medium">
                          <i className="ri-check-line text-xl"></i>
                          {row.mirokids}
                        </span>
                      </td>
                      <td className="py-5 px-6 text-center text-gray-600">{row.traditional}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">准备好开始了吗？</h2>
          <p className="text-xl mb-8 text-blue-100">
            寻找您身边的认证医生，开启孩子的微笑之旅
          </p>
          <Link 
            to="/find-doctor"
            className="whitespace-nowrap inline-block bg-white text-blue-600 hover:bg-blue-50 px-10 py-4 rounded-full text-lg font-bold transition-colors shadow-lg cursor-pointer"
          >
            寻找医生
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Product;